import React, { useCallback, useMemo } from 'react';
import { Box, costFormater, Inscription, LinkButton, NewTabIcon } from '@common-fe/common-fe';

import routes from '@/common/routes';

import BankingBalancePlanOmnibusHint from './BankingBalancePlanOmnibusHint';

interface Props {
  balance: number;
  planId: number;
  orgId?: string;
}

const BankingBalancePlanOmnibus: React.FC<Props> = ({ balance, planId, orgId }) => {

  const handleOpenOmnibusReport = useCallback(() => {
    const params = new URLSearchParams({
      tab: 'BREAKDOWN',
      isSSNShowed: 'false',
      isContributionMode: 'true',
      ...(orgId ? { employerId: orgId } : {}),
      ...(planId ? { reportPlanIds: String(planId) } : {}),
    });

    window.open(`${routes.PLAN_OMNIBUS_BALANCE_REPORT}?${params.toString()}`, '_blank');
  }, [orgId, planId]);

  const isPositiveBalance = useMemo(() => balance > 0, [balance]);

  return (
    <Box
      data-testid={`plan-omnibus_${planId}`}
      gap="spacing8"
      margin={{ top: 'spacing16' }}
    >
      <Box
        direction="row"
        align="center"
        justify="between"
        pad={{ horizontal: 'spacing8', vertical: 'spacing6' }}
        background="#FDECC0"
        round="button2Round"
      >
        <Inscription size="14px" lineHeight="20px">
          Plan omnibus
        </Inscription>
        <Box direction="row" align="center">
          <BankingBalancePlanOmnibusHint testId={`plan-omnibus_${planId}_hint`} />
          <Box margin={{ left: 'spacing4' }}>
            <Inscription
              weight="bold"
              size="14px"
              lineHeight="20px"
              color={isPositiveBalance ? 'textBody' : 'danger'}
            >
              {costFormater(balance, true)}
            </Inscription>
          </Box>
        </Box>
      </Box>
      <Box width="fit-content">
        <LinkButton
          testId={`plan-omnibus_${planId}_report-button`}
          onClick={handleOpenOmnibusReport}
          rightIcon={<NewTabIcon />}
        >
          Omnibus Report
        </LinkButton>
      </Box>
    </Box>
  );
};

export default BankingBalancePlanOmnibus;
